import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight, ShieldCheck, CreditCard } from 'lucide-react';
import { trackMetaEvent } from '../hooks/useMetaPixel';
export function OfferStack() {
  return <section id="oferta" className="py-24 px-4 md:px-8 bg-cream" data-id="element-85">
      <div className="max-w-4xl mx-auto" data-id="element-86">
        <div className="text-center mb-12" data-id="element-87">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-brown-deep mb-4" data-id="element-88">
            ¿Lista para el cambio?
          </h2>
          <p className="text-xl text-brown-medium" data-id="element-89">
            21 días separan tu versión actual de tu versión "Efecto Vacío"
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-gold/20 relative" data-id="element-90">
          {/* Badge */}
          <div className="bg-gold text-white text-center py-3 font-bold tracking-widest text-sm uppercase" data-id="element-91">
            TRATAMIENTO COMPLETO
          </div>

          <div className="p-8 md:p-12 grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-92">
            {/* Left: What you get */}
            <div data-id="element-93">
              <h3 className="text-2xl font-serif font-bold text-brown-deep mb-6" data-id="element-94">
                Tu Kit Incluye:
              </h3>
              <ul className="space-y-4" data-id="element-95">
                {['Faja Térmica Premium', 'Ebook Método 21D (Protocolo Digital)', 'Guía de Masajes Linfáticos', 'Soporte por WhatsApp'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-96">
                    <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-97">
                      <Check className="w-4 h-4 text-green-600" data-id="element-98" />
                    </div>
                    <span className="text-brown-deep font-medium" data-id="element-99">{item}</span>
                  </li>)}
              </ul>
              <div className="mt-8 p-4 bg-rose/30 rounded-lg border border-rose text-brown-deep text-sm" data-id="element-100">
                <span className="font-bold" data-id="element-101">🎁 Bonus:</span> Acceso a comunidad
                exclusiva de clientas.
              </div>
            </div>

            {/* Right: Price & CTA */}
            <div className="text-center md:text-left flex flex-col items-center md:items-start" data-id="element-102">
              <div className="mb-2 text-gray-400 line-through text-xl font-medium" data-id="element-103">
                $89.990
              </div>
              <div className="text-5xl md:text-6xl font-bold text-coral mb-2" data-id="element-104">
                $49.990
              </div>
              <div className="text-lg text-brown-medium font-medium mb-4" data-id="element-105">
                o{' '}
                <span className="font-bold text-brown-deep" data-id="element-106">
                  3 cuotas sin interés de $16.663
                </span>
              </div>
              <div className="inline-block px-4 py-1 bg-green-100 text-green-700 rounded-full text-sm font-bold mb-8" data-id="element-107">
                Ahorrás $40.000 vs. una sesión de estética
              </div>

              <a href="https://argrutinas.com/cart/42975513477329:1" target="_blank" rel="noopener noreferrer" onClick={() => trackMetaEvent('AddToCart', {
              content_name: 'Kit Vientre Plano 21D',
              content_type: 'product',
              value: 49990,
              currency: 'ARS'
            })} className="w-full py-4 bg-coral hover:bg-coral-dark text-white rounded-full font-bold text-lg shadow-lg shadow-coral/30 transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2 mb-4 group no-underline" data-id="element-108">
                <span data-id="element-109">QUIERO MI KIT AHORA</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-110" />
              </a>

              <div className="flex items-center justify-center md:justify-start gap-4 text-xs text-gray-500 w-full" data-id="element-111">
                <div className="flex items-center gap-1" data-id="element-112">
                  <ShieldCheck className="w-4 h-4" data-id="element-113" />
                  <span data-id="element-114">Pago seguro</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-115">
                  <CreditCard className="w-4 h-4" data-id="element-116" />
                  <span data-id="element-117">Envío a todo el país</span>
                </div>
              </div>
            </div>
          </div>

          {/* Glow Effect */}
          <div className="absolute inset-0 pointer-events-none border-4 border-gold/10 rounded-3xl animate-pulse-slow" data-id="element-118"></div>
        </motion.div>
      </div>
    </section>;
}